import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  // totalRows: 0,
  data_details:[],
  lastUpdated:"",
  filterDatas:{}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_INSTALLED_INFO_SEARCH:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_INSTALLED_INFO_SEARCH:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        // totalRows: action.items.DataCount,
        lastUpdated: action.receivedAt
      }
    
      case ActionTypes.REQUEST_INSTALLED_INFO_DETAIL:
        return {
          ...state,
          isFetching: true,
          didInvalidate: false,
        }

    case ActionTypes.RECEIVE_INSTALLED_INFO_DETAIL:
      return {
        ...state,
        isFetching: false,
        data_details: action.data_details,
        lastUpdated: action.lastTime,
      }

    default:
      return state
  }
}